module.exports = __webpack_public_path__ + "static/media/top-notch.2f8bd4dd.svg";